import React from "react"

export const WistiaVideoModal = ({ modal_active, close_modal }) => {
  return (
    <div data-nosnippet className={`modal${modal_active ? " is-active" : ""}`}>
      <div
        className="modal-background"
        style={{
          backgroundColor: "rgba(14, 29, 40, 0.95)",
        }}
        onClick={close_modal}
        role="button"
        tabIndex="-1"
        onKeyDown={() => {}}
        aria-label="Close Modal"
      ></div>
      <button
        className="modal-close is-large"
        onClick={close_modal}
        aria-label="close"
      ></button>
      <div
        className="modal-content"
        style={{ maxWidth: "90vw", overflow: "hidden" }}
      >
        <div
          className="wistia_responsive_padding"
          style={{
            padding: "56.25% 0 0 0",
            position: "relative",
          }}
        >
          <div
            className="wistia_responsive_wrapper"
            style={{
              height: "100%",
              position: "absolute",
              top: 0,
              width: "100%",
            }}
          >
            <iframe
              src="https://fast.wistia.net/embed/iframe/08cygt8kbb?seo=false&videoFoam=true"
              title="Wir präsentieren: Die neue Ausschreibungsdatenbank von B_I MEDIEN, + cta Video"
              allow="autoplay; fullscreen"
              allowtransparency="true"
              className="wistia_embed"
              name="wistia_embed"
              msallowfullscreen="true"
              width="100%"
              height="100%"
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  )
}
